"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7109],{

/***/ 9825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);






var SvgCheckmark = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size) {
        outProps.width = size;
        outProps.height = size;
    }
    if (color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m9.218 15.319 9.967-9.966Q19.537 5 20.022 5q.486 0 .838.353.354.352.353.838 0 .484-.353.838L10.042 17.847q-.354.353-.824.353t-.823-.353L3.34 12.791A1.1 1.1 0 0 1 3 11.953a1.2 1.2 0 0 1 .367-.838q.353-.353.838-.353t.838.353z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCheckmark);


/***/ }),

/***/ 48050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);






var SvgPasswordShow = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size) {
        outProps.width = size;
        outProps.height = size;
    }
    if (color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "M12.002 15.577q1.7 0 2.887-1.19t1.188-2.89-1.19-2.886-2.89-1.188-2.886 1.19-1.188 2.89 1.19 2.886 2.89 1.188M12 14.2q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.788.788 1.913t-.787 1.912A2.6 2.6 0 0 1 12 14.2m0 4.3q-3.157 0-5.776-1.685a12.6 12.6 0 0 1-4.18-4.432 1.8 1.8 0 0 1-.182-.434 1.75 1.75 0 0 1 .182-1.332 12.6 12.6 0 0 1 4.18-4.432Q8.842 4.5 12 4.5t5.776 1.685a12.6 12.6 0 0 1 4.18 4.432q.125.216.182.434a1.75 1.75 0 0 1-.182 1.332 12.6 12.6 0 0 1-4.18 4.432Q15.158 18.5 12 18.5m0-1.5a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.612 4.012A9.54 9.54 0 0 0 12 17"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPasswordShow);


/***/ }),

/***/ 55285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11141);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7238);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74609);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36838);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84402);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button;
var sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_2__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
};
var AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
}));
var ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
}));
var AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
});
/**
 * The TextButton component is a pressable element that's styled to be
 * less-pronounced than the regular Button component. The component is similar
 * to the "nav" variant of the Link component in the old version of bricks. In
 * this version of bricks, TextButton and Link are separate components. Use Link
 * when the clickable text should be inline with other text (e.g., in the middle
 * of a paragraph), and use TextButton when the clickable text should be set off
 * on its own. With TextButton, you can also pass a `chevronIcon` prop to show a
 * chevron on either the left or the right side of the button text.
 *
 * Like Button, TextButton accepts an `href` prop that lets you use the
 * component for URL-based navigation. Refer to the Button component docs for
 * more information. Also refer to the Button docs for information on flexbox
 * and analytics props.
 */ var TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function TextButton(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, _size = _param.size, size = _size === void 0 ? "medium" : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight",
        "size"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isHovering = _$ref[0], setIsHovering = _$ref[1];
    var hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.useMedia)().hoverNone;
    var handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(true);
        onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]);
    var handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(false);
        onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]);
    var color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : undefined,
                children: label
            }),
            chevronIcon === "right" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});


/***/ }),

/***/ 78514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _shared_TextInputBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80841);





/**
 * Use TextInput to collect single-line text from the user. For multiline text,
 * use TextArea.
 *
 * If you want validation to be handled for you, use ValidatedTextInput instead
 * (it's a controlled input component that validates & formats for you).
 *
 * TextInput always takes up the full width of its container. To limit its
 * width, wrap it in a Box or other container component.
 *
 * To use TextInput as an uncontrolled component, leave the `value` prop
 * undefined. To use it as a controlled component, pass `value` and
 * `onChangeText`. If you need to prefill the input but still want to use an
 * uncontrolled component, use the `prefilledValue` prop.
 *
 * You must pass a `title` prop. This is so we can ensure that the input meets
 * accessibility requirements for screen readers.
 * In the rare case that you can't pass a `title` prop, make sure to pass `ariaLabel` or `ariaLabelledBy` instead.
 *
 * If you want to track impression events ("inputViewEvent"), pass
 * `analyticsName` and `trackImpression`.
 *
 * TextInput supports a subset of [React Native's TextInput props](
 * https://reactnative.dev/docs/textinput). One notable prop is [autoComplete](
 * https://reactnative.dev/docs/textinput#autocomplete) — make sure to include
 * `autoComplete` whenever relevant so the user's device can offer useful
 * suggestions for filling out the input. Another prop to know about is
 * [autoFocus](https://reactnative.dev/docs/textinput#autofocus) — be careful
 * when using `autoFocus` because it can cause confusing behavior. Automatically
 * focusing on a control can make the page scroll on load and cause users to
 * miss context created by content earlier on the page. It can also cause
 * dynamic keyboards to display over the page on touch devices. For
 * screen-readers, it can "teleport" the user to the form control without
 * warning them or announcing anything on the page before the control's label.
 */ var TextInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function TextInput(props, ref) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_shared_TextInputBase__WEBPACK_IMPORTED_MODULE_2__/* .TextInputBase */ .y, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        ref: ref
    }));
});



/***/ }),

/***/ 63060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ InputError; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64069);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22901);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84402);




var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput;
/**
 * Error message for input components
 */ var InputError = function(param) {
    var errorText = param.errorText;
    return !!errorText && typeof errorText === "string" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        testID: "text-input-error-message",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            typography: textInputTokens.typography.errorText.default,
            color: textInputTokens.color.content.errorMessage.default,
            children: errorText
        })
    }) : null;
};


/***/ }),

/***/ 16660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ InputFrame; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91158);



var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput;
/**
 * Container component shared by different kinds of input components
 */ var InputFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
    backgroundColor: textInputTokens.color.background.default,
    flexDirection: "row",
    gap: textInputTokens.padding.gap.textAndIcon.default,
    animation: "linear",
    animateOnly: _tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb ? [
        "border-color",
        "border-top-color",
        "border-left-color",
        "border-bottom-color",
        "border-right-color", 
    ] : [
        "borderColor",
        "borderTopColor",
        "borderLeftColor",
        "borderBottomColor",
        "borderRightColor"
    ],
    variants: {
        size: function(size) {
            return {
                borderRadius: textInputTokens.cornerRadius[size],
                paddingVertical: textInputTokens.padding.topBottom[size],
                paddingHorizontal: textInputTokens.padding.leftRight[size],
                height: size in textInputTokens.size.height ? textInputTokens.size.height[size] : undefined
            };
        },
        state: function(state) {
            var backgroundColor = (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(state, textInputTokens.color.background.state) ? textInputTokens.color.background.state[state] : textInputTokens.color.background.default;
            var borderColor = state ? textInputTokens.color.border.state[state] : textInputTokens.color.border.default;
            var borderWidth = textInputTokens.borderWidth.default;
            var hoverStyle = state ? {} : {
                borderColor: textInputTokens.color.border.state.hover
            };
            var cursor = state === "inactive" ? "default" : "text";
            return {
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderWidth: borderWidth,
                hoverStyle: hoverStyle,
                cursor: cursor
            };
        }
    }
});


/***/ }),

/***/ 77651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ InputLabel; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64069);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91158);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);
/* harmony import */ var _shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26487);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84402);






var textInputTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.textInput */ .T.textInput;
/**
 * Label for input components
 */ var InputLabel = function(param) {
    var size = param.size, title = param.title, supportText = param.supportText, id = param.id, required = param.required, state = param.state;
    (0,_shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_1__/* .useCheckInputLabel */ .B)(title);
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        gap: textInputTokens.padding.gap.titleAndSupport.default,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "label",
                htmlFor: id,
                typography: textInputTokens.typography.fieldTitle[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, textInputTokens.color.content.fieldTitle.state) ? textInputTokens.color.content.fieldTitle.state[state] : textInputTokens.color.content.fieldTitle.default,
                children: [
                    title,
                    required ? " *" : ""
                ]
            }),
            !!supportText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "span",
                typography: textInputTokens.typography.supportText.default,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, textInputTokens.color.content.supportText.state) ? textInputTokens.color.content.supportText.state[state] : textInputTokens.color.content.supportText.default,
                children: supportText
            })
        ]
    });
};


/***/ }),

/***/ 80841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ TextInputBase; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/PasswordShow.tsx
var PasswordShow = __webpack_require__(48050);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/PasswordHide.tsx
var PasswordHide = __webpack_require__(56867);
// EXTERNAL MODULE: ../bricks-next/src/helpers/fontTokens.ts
var fontTokens = __webpack_require__(63501);
// EXTERNAL MODULE: ../bricks-next/src/helpers/utils.ts
var utils = __webpack_require__(91158);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
// EXTERNAL MODULE: ../bricks-next/src/components/shared/TrackableContainer.tsx
var TrackableContainer = __webpack_require__(90143);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/hooks.ts
var hooks = __webpack_require__(39390);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputError.tsx
var InputError = __webpack_require__(63060);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputFrame.tsx
var InputFrame = __webpack_require__(16660);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputLabel.tsx
var InputLabel = __webpack_require__(77651);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/TextInput/index.js
var TextInput = __webpack_require__(26114);
;// CONCATENATED MODULE: ../bricks-next/src/components/inputs/shared/TextInputField.tsx



var textInputTokens = Components/* tokens.textInput */.T.textInput;
/**
 * Styled text input shared by different kinds of input components
 */ var TextInputField = (0,cjs.styled)(TextInput/* default */.Z, {
    focusable: true,
    borderWidth: 0,
    outlineStyle: "none",
    fontFamily: "$body",
    placeholderTextColor: textInputTokens.color.content.placeholderText.default,
    backgroundColor: "$transparent",
    // This is a workaround for a style set by primer.css
    // @ts-expect-error - RNTextInput does not have a boxShadow prop
    boxShadow: cjs.isWeb ? "none" : undefined,
    variants: {
        size: function(size) {
            return {
                fontSize: textInputTokens.typography.valueText[size],
                fontWeight: textInputTokens.typography.valueText[size],
                letterSpacing: textInputTokens.typography.valueText[size]
            };
        }
    }
}, {
    isInput: true,
    accept: {
        placeholderTextColor: "color"
    }
});

;// CONCATENATED MODULE: ../bricks-next/src/components/inputs/shared/TextInputBase.tsx


















var TextInputBase_textInputTokens = Components/* tokens.textInput */.T.textInput;
var PrefixSuffixText = function(_param) {
    var size = _param.size, state = _param.state, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "state",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tag: "span",
        typography: TextInputBase_textInputTokens.typography.valueText[size],
        color: (0,utils/* isKeyOfObject */.E)(state, TextInputBase_textInputTokens.color.content.prefixSuffix.state) ? TextInputBase_textInputTokens.color.content.prefixSuffix.state[state] : TextInputBase_textInputTokens.color.content.prefixSuffix.default
    }, props), {
        children: children
    }));
};
/**
 * TextInputBase is the base component used for input components like TextInput and TextArea
 */ var TextInputBase = /*#__PURE__*/ (0,react.forwardRef)(function TextInputBase(_param, ref) {
    var title = _param.title, supportText = _param.supportText, id = _param.id, name = _param.name, value = _param.value, prefilledValue = _param.prefilledValue, placeholder = _param.placeholder, errorText = _param.errorText, invalid = _param.invalid, ariaLabel = _param.ariaLabel, ariaLabelledBy = _param.ariaLabelledBy, disabled = _param.disabled, required = _param.required, prefix = _param.prefix, suffix = _param.suffix, multiline = _param.multiline, onFocus = _param.onFocus, onBlur = _param.onBlur, onChangeText = _param.onChangeText, analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, textContentType = _param.textContentType, suggestion = _param.suggestion, onSuggestion = _param.onSuggestion, frameProps = _param.frameProps, children = _param.children, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "supportText",
        "id",
        "name",
        "value",
        "prefilledValue",
        "placeholder",
        "errorText",
        "invalid",
        "ariaLabel",
        "ariaLabelledBy",
        "disabled",
        "required",
        "prefix",
        "suffix",
        "multiline",
        "onFocus",
        "onBlur",
        "onChangeText",
        "analyticsName",
        "trackImpression",
        "textContentType",
        "suggestion",
        "onSuggestion",
        "frameProps",
        "children"
    ]);
    var _ref = (0,cjs.useProps)(propsIn), _size = _ref.size, size = _size === void 0 ? "medium" : _size, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "size"
    ]);
    var _$ref = (0,react.useState)(textContentType === "password"), showPassword = _$ref[0], setShowPassword = _$ref[1];
    var inputId = (0,hooks/* useInputId */.U0)(id);
    var elementRef = (0,hooks/* useInputName */.Gd)(name);
    var combinedRefs = (0,cjs.useComposedRefs)(ref, elementRef);
    var _$ref1 = (0,hooks/* useFrameFocus */.N7)(combinedRefs), inputRef = _$ref1.inputRef, handleFramePress = _$ref1.handleFramePress;
    var _$ref2 = (0,hooks/* useInputState */.U1)({
        disabled: disabled,
        errorText: errorText,
        invalid: invalid,
        onBlur: onBlur,
        onFocus: onFocus
    }), state = _$ref2.state, handleFocus = _$ref2.handleFocus, handleBlur = _$ref2.handleBlur;
    var heightProps = (0,react.useMemo)(function() {
        return getInputHeightProps({
            multiline: multiline,
            size: size
        });
    }, [
        multiline,
        size
    ]);
    var _$ref3;
    var _$ref4 = (0,react.useState)((_$ref3 = value !== null && value !== void 0 ? value : prefilledValue) !== null && _$ref3 !== void 0 ? _$ref3 : ""), internalValue = _$ref4[0], setInternalValue = _$ref4[1];
    var handleTextChange = function(text) {
        setInternalValue(text);
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(text);
    };
    var _$ref5;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        gap: TextInputBase_textInputTokens.padding.gap.textAndField[size],
        eventName: "inputViewEvent",
        children: [
            !!title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputLabel/* InputLabel */.A, {
                size: size,
                state: state,
                title: title,
                supportText: supportText,
                id: inputId,
                required: required
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputFrame/* InputFrame */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                size: size,
                state: state,
                onPress: handleFramePress
            }, frameProps), {
                flex: multiline ? 0 : 1,
                overflow: multiline ? "hidden" : undefined,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flex: 1,
                        flexDirection: "row",
                        alignItems: multiline ? "flex-start" : "center",
                        gap: TextInputBase_textInputTokens.padding.gap.prefixValueSuffix.default,
                        children: [
                            !!prefix && typeof prefix === "string" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefixSuffixText, {
                                size: size,
                                state: state,
                                children: prefix
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                flexShrink: 1,
                                flexGrow: 1,
                                overflow: multiline ? "hidden" : undefined,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInputField, (0,_object_spread/* default */.Z)({
                                    secureTextEntry: showPassword,
                                    size: size,
                                    color: (0,utils/* isKeyOfObject */.E)(state, TextInputBase_textInputTokens.color.content.valueText.state) ? TextInputBase_textInputTokens.color.content.valueText.state[state] : TextInputBase_textInputTokens.color.content.valueText.default,
                                    id: inputId,
                                    value: value,
                                    defaultValue: prefilledValue,
                                    placeholder: placeholder,
                                    disabled: disabled,
                                    editable: !disabled,
                                    onFocus: handleFocus,
                                    onBlur: handleBlur,
                                    onChangeText: handleTextChange,
                                    ref: inputRef,
                                    "aria-invalid": !!errorText || invalid,
                                    "aria-required": required,
                                    "aria-label": ariaLabel,
                                    "aria-labelledby": ariaLabelledBy,
                                    multiline: multiline,
                                    textContentType: textContentType,
                                    scrollEnabled: multiline
                                }, heightProps, props))
                            }),
                            !!suffix && typeof suffix === "string" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        opacity: 0,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefixSuffixText, {
                                            size: size,
                                            state: state,
                                            "aria-hidden": true,
                                            children: suffix
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        flexDirection: "row",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        overflow: "hidden",
                                        alignItems: "center",
                                        gap: TextInputBase_textInputTokens.padding.gap.prefixValueSuffix.default,
                                        "aria-hidden": true,
                                        children: [
                                            !!prefix && typeof prefix === "string" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefixSuffixText, {
                                                size: size,
                                                state: state,
                                                "aria-hidden": true,
                                                children: prefix
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: TextInputBase_textInputTokens.typography.valueText[size],
                                                numberOfLines: 1,
                                                flexShrink: 1,
                                                opacity: 0,
                                                "aria-hidden": true,
                                                children: (_$ref5 = value !== null && value !== void 0 ? value : prefilledValue) !== null && _$ref5 !== void 0 ? _$ref5 : internalValue
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefixSuffixText, {
                                                size: size,
                                                state: state,
                                                "aria-hidden": false,
                                                children: suffix
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    textContentType === "password" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        "aria-label": "Toggle password visibility",
                        testID: "show-password-toggle",
                        analyticsName: "show-password-toggle",
                        onPress: function() {
                            setShowPassword(!showPassword);
                        },
                        children: showPassword ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordShow/* default */.Z, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordHide/* default */.Z, {})
                    }),
                    children
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
                errorText: errorText
            }),
            !suggestion ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                "aria-label": "",
                analyticsName: "input-suggestion",
                onPress: onSuggestion,
                testID: "input-suggestion",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                    tag: "span",
                    mt: "$4x",
                    color: "$contentAccentBrand",
                    cursor: "pointer",
                    typography: TextInputBase_textInputTokens.typography.supportText.default,
                    children: [
                        'Did you mean "',
                        suggestion,
                        '"?'
                    ]
                })
            })
        ]
    });
});
var getInputHeightProps = function(param) {
    var multiline = param.multiline, size = param.size;
    var props = {};
    var lineHeightToken = TextInputBase_textInputTokens.typography.valueText[size];
    // For some reason providing a lineHeight to single-line inputs on iOS cuts off
    // descenders like "g" and "y", so for now let's only provide it for Android/web
    // and use height on iOS instead. Possibly fixed in a later version of React Native
    // by this PR: https://github.com/facebook/react-native/pull/38359
    if (cjs.isIos && !multiline) {
        var ref;
        var lineHeightTokenVariable = (ref = (0,fontTokens/* getLineHeightTokens */.aT)()) === null || ref === void 0 ? void 0 : ref[lineHeightToken];
        props.height = lineHeightTokenVariable && typeof lineHeightTokenVariable !== "number" ? lineHeightTokenVariable === null || lineHeightTokenVariable === void 0 ? void 0 : lineHeightTokenVariable.val : undefined;
    } else {
        props.lineHeight = lineHeightToken;
    }
    if (multiline) {
        var numberOfLines = (0,cjs.getTokenValue)(Components/* tokens.textInput.text.row.multiline.default */.T.textInput.text.row.multiline["default"], "text");
        props.numberOfLines = numberOfLines;
        props.textAlignVertical = "top";
        props.lineHeight = lineHeightToken;
    }
    return props;
};


/***/ }),

/***/ 39390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ useInputName; },
/* harmony export */   "N7": function() { return /* binding */ useFrameFocus; },
/* harmony export */   "U0": function() { return /* binding */ useInputId; },
/* harmony export */   "U1": function() { return /* binding */ useInputState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);



var useInputId = function(id) {
    var backupId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    return id || backupId;
};
/**
 * There's a bug in tamagui where the `name` attribute doesn't get set on
 * styled components. See: https://github.com/tamagui/tamagui/issues/2495
 *
 * Use this hook to manually set the `name` attribute on styled components. Note
 * that this attribute must be used on inputs if you want to use the FormData
 * API (without it, `new FormData(<form element>)` will be empty).
 */ var useInputName = function(name) {
    // Have to use `any` because we need it to be an HTMLElement here but
    // elsewhere we use React Native types, which don't have `setAttribute`
    // (in reality, `setAttribute` will exist when `isWeb` is true)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb && name && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref.current, HTMLElement)) {
            var ref1;
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("name", name);
        }
    }, [
        name
    ]);
    return ref;
};
var useFrameFocus = function(ref) {
    var focusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var inputRef = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.useComposedRefs)(ref, focusRef);
    var handleFramePress = function() {
        var _$ref;
        (_$ref = focusRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
    };
    return {
        inputRef: inputRef,
        handleFramePress: handleFramePress
    };
};
var useInputState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), focused = ref[0], setFocused = ref[1];
    var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(true);
        onFocus && onFocus(e);
    }, [
        onFocus
    ]);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    var state = disabled ? "inactive" : errorText || invalid ? "error" : focused ? "focused" : undefined;
    return {
        state: state,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
};


/***/ }),

/***/ 26487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useCheckInputLabel; },
/* harmony export */   "F": function() { return /* binding */ InputLabelContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

/**
 * Context used to coordinate layout properties across form page components.
 * Only used internally.
 */ var InputLabelContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/**
 * @throws
 * Throws an error if an input element is rendered without an accessible label.
 * The label can be inside the input component or outside the component if the
 * component's id is provided to InputLabelContext.
 */ var useCheckInputLabel = function(label) {
    var inputId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(InputLabelContext).inputId;
    if (!inputId && !label) {
        throw new Error("Tried to render an input element without an accessible label. Please check that all input components have a non-empty `title` prop.");
    }
};


/***/ }),

/***/ 90143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TrackableContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77453);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);






/**
 * Container component for tracking components
 */ var TrackableContainer = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, eventName = _param.eventName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "eventName"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var Component = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    if (analyticsName && trackImpression) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ComponentWithViewTracking */ .o, {
            Component: Component,
            analyticsName: analyticsName,
            eventName: eventName,
            ref: ref
        });
    }
    return Component;
};


/***/ }),

/***/ 63501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pp": function() { return /* binding */ getTypographyCSSVariable; },
/* harmony export */   "Yp": function() { return /* binding */ getTypographyValue; },
/* harmony export */   "Yw": function() { return /* binding */ getFontName; },
/* harmony export */   "aT": function() { return /* binding */ getLineHeightTokens; }
/* harmony export */ });
/* unused harmony exports getFontTokens, getFontSizeTokens, getLetterSpacingTokens, getFontWeightTokens, getFontTokenKeys */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__);

var getFontTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getConfig)().fontsParsed[fontKey];
};
var getFontSizeTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).size;
};
var getLineHeightTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).lineHeight;
};
var getLetterSpacingTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).letterSpacing;
};
var getFontWeightTokens = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    return getFontTokens(fontKey).weight;
};
var getFontTokenKeys = function() {
    var fontKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$body";
    var fontSizeTokens = getFontSizeTokens(fontKey);
    return Object.keys(fontSizeTokens);
};
var getTypographyCSSVariable = function(token, property) {
    var fontKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$body";
    var ref;
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableVariable)((ref = getFontTokens(fontKey)[property]) === null || ref === void 0 ? void 0 : ref[token]);
};
var getFontName = function() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "400", fontKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "$body", isForWeb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isWeb;
    var ref, ref1;
    if (isForWeb) {
        var family = getFontTokens(fontKey)["family"];
        return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(family);
    }
    var fontFace = (ref = getFontTokens(fontKey)["face"]) === null || ref === void 0 ? void 0 : (ref1 = ref[weight]) === null || ref1 === void 0 ? void 0 : ref1.normal;
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(fontFace);
};
var getTypographyValue = function(token, property) {
    var fontKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$body";
    var ref;
    var variable = (ref = getFontTokens(fontKey)[property]) === null || ref === void 0 ? void 0 : ref[token];
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(variable);
};


/***/ }),

/***/ 91158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isKeyOfObject; }
/* harmony export */ });
/**
 * Returns whether the given key is a key of the given object.
 */ function isKeyOfObject(key, obj) {
    return !!key && key in obj;
}


/***/ })

}]);